<router-outlet></router-outlet>
<ngx-ui-loader [fgsColor]="agentPrimaryColor"></ngx-ui-loader>
